// @ts-nocheck

import dash_api from '../../main/support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
const GetWebhooks = new ReduxAsyncAction('GET_WEBHOOKS');
GetWebhooks.registerRequest(function () {
  return dash_api.get('/v1/webhook').then((res) => {
    return res.data;
  });
});
export const GET_WEBHOOKS = GetWebhooks.constants;
export const getWebhooks = GetWebhooks.request;
const CreateWebhook = new ReduxAsyncAction('CREATE_WEBHOOK');
CreateWebhook.registerRequest(function (data) {
  return dash_api.post('/v1/webhook', data).then((res) => {
    return res.data;
  });
});
export const CREATE_WEBHOOK = CreateWebhook.constants;
export const createWebhook = CreateWebhook.request;
const UpdateWebhook = new ReduxAsyncAction('UPDATE_WEBHOOK');
UpdateWebhook.registerRequest(function (data) {
  return dash_api.put('/v1/webhook', data).then((res) => {
    return res.data;
  });
});
export const UPDATE_WEBHOOK = UpdateWebhook.constants;
export const updateWebhook = UpdateWebhook.request;
const ValidatePostback = new ReduxAsyncAction('VALIDATE_POSTBACK');
ValidatePostback.registerRequest((data) => dash_api.post('/v1/webhook/validate-template', data).then((res) => res.data));
export const VALIDATE_POSTBACK = ValidatePostback.constants;
export const validatePostback = ValidatePostback.request;
